<script setup>
import moment from "moment"
moment.locale('id');
</script>
<template>  
    <div class="evaluation-table-container" v-if="penilaians!=null&&penilaians.length>0">
        
        <div v-for="(pp, idx) in penilaians" :key="idx" class="mb-4">
            <div class="p-2">
                Nama Kustodian : <b>{{ pp.kustodian }}</b>
            </div >
            <table class="evaluation-table" >
                <thead>
                    <tr class="evaluation-table-heading">
                        <th style="background-color: #f8d7da; width: 7%;">
                            No.
                        </th>
                        <th style="background-color: #f8d7da; width: 33%;">
                            Kriteria Penilaian
                        </th>
                        <th style="background-color: #f8d7da; width: 7%;">
                            Skor Max
                        </th>
                        <th style="background-color: #f8d7da; width: 17%;">
                            Skor
                        </th>
                        <th style="background-color: #f8d7da; width: 36%;">
                            Catatan
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in pp.penilaian" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.aspek }}</td>
                        <td>{{ item.skorMax==null?defaultSkorMax:item.skorMax }} </td>
                        <td> 
                            <div class="input-group" style="width: 150px;" v-if="(pp.idKustodian==userData.id) && (moment(dataPJO.tanggalPresentasi).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) && (dataSio.status!=5&&dataSio.status!=6)">
                                <div class="input-group-prepend">
                                    <div class="input-group-text pointer" @click="decreaseScoreS(idx,index)">
                                        &nbsp;
                                        <font-awesome-icon style="color: #dc3545;" icon="fa-solid fa-circle-minus" />
                                    </div>
                                </div>
                                <input type="text" class="form-control" disabled style="text-align: center;" :value="item.skor==null?0:item.skor">
                                <div class="input-group-prepend">
                                    <div class="input-group-text pointer" @click="increaseScoreS(idx,index)">
                                        <font-awesome-icon style="color: #dc3545;" icon="fa-solid fa-circle-plus" />
                                        &nbsp;
                                    </div>
                                </div>
                            </div>
                            <div class="" v-else>
                                <span>{{ item.skor==null?0:item.skor }}</span>
                            </div>
                        </td>
                        <td>
                            <div v-if="(pp.idKustodian==userData.id) && (moment(dataPJO.tanggalPresentasi).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) && (dataSio.status!=5&&dataSio.status!=6)">
                                <div v-if="!item.isEditingNote" class="d-flex justify-content-between align-items-start gap-2">
                                    <div class="flex-grow-1" style="min-width: 0;">
                                        <div
                                            class="text-wrap line-clamp-2 break-words"
                                            v-html="ncDescWithBreaks(item.catatan)"
                                        ></div>

                                    <h4
                                        v-if="isCatatanLong(item.catatan)"
                                        class="mt-1 font-semibold text-green-600 text-xs cursor-pointer hover:underline w-fit"
                                        @click="openTextDetail('Catatan', item.catatan, item.aspek)"
                                    >
                                        Lihat Selengkapnya
                                    </h4>
                                </div>
                                    <div class="flex-shrink-0 ms-2">
                                        <font-awesome-icon 
                                            icon="fa-solid fa-pencil-alt" 
                                            @click="startEditNoteS(idx,index)" 
                                            class="pointer" 
                                            style="color: #dc3545;" 
                                        />
                                    </div>
                                </div>
                                <div v-else style="text-align: center;">
                                    <textarea class="form-control" rows="2" v-model="item.editNote"></textarea>

                                    <button class="btn btn_cari w-25" @click="saveEditNoteS(idx,index)" style="margin-top: 5px; ">
                                        Simpan
                                    </button>

                                    <button class="btn btn-secondary" @click="cancelEditNoteS(idx,index)" style="margin-top: 5px; margin-left: 5px;">
                                        Batalkan
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <div
                                    class="text-wrap line-clamp-2 break-words"
                                    v-html="ncDescWithBreaks(item.catatan)"
                                ></div>

                                <h4
                                    v-if="isCatatanLong(item.catatan)"
                                    class="mt-1 font-semibold text-green-600 text-xs cursor-pointer hover:underline w-fit"
                                    @click="openTextDetail('Catatan', item.catatan, item.aspek)"
                                >
                                    Lihat Selengkapnya
                                </h4>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td style="background: #ebecec; text-align: center;" colspan="2">Total</td>
                        <td style="background: #ebecec;">{{ totalMaxScoreAdmin(pp.penilaian) }}</td>
                        <td style="background: #ebecec;" colspan="2">{{ totalScoreAdmin(pp.penilaian) }}</td>
                    </tr>
                    <tr>
                        <td style="background: #e0e2e4; text-align: center;" colspan="2">Score</td>
                        <td style="background: #e0e2e4;"></td>
                        <td style="background: #e0e2e4;" colspan="2">{{ finalScoreAdmin(pp.penilaian) }}</td>
                    </tr>
                </tfoot>
            </table> 
        </div>
        <template v-if="penilaians.filter(item => item.idKustodian==userData.id).length==0&&(evaluationItems!=null&&evaluationItems.length>0)&&idKustodian==userData.id">
            <div class="p-2">
                Nama Kustodian : <b>{{ namaKustodian}}</b>
            </div >
             <table class="evaluation-table" >
            <thead>
                <tr class="evaluation-table-heading">
                    <th style="background-color: #f8d7da; width: 7%;">
                        No.
                    </th>
                    <th style="background-color: #f8d7da; width: 33%;">
                        Kriteria Penilaian
                    </th>
                    <th style="background-color: #f8d7da; width: 7%;">
                        Skor Max
                    </th>
                    <th style="background-color: #f8d7da; width: 17%;">
                        Skor
                    </th>
                    <th style="background-color: #f8d7da; width: 36%;">
                        Catatan
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in evaluationItems" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.aspek }}</td>
                    <td>{{ item.skorMax==null?defaultSkorMax:item.skorMax }}</td>
                    <td> 
                        <div class="input-group" style="width: 150px;" v-if="idKustodian==userData.id&&(moment(dataPJO.tanggalPresentasi).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) && (dataSio.status!=5&&dataSio.status!=6)">
                            <div class="input-group-prepend">
                                <div class="input-group-text pointer" @click="decreaseScore(index)">
                                    &nbsp;
                                    <font-awesome-icon style="color: #dc3545;" icon="fa-solid fa-circle-minus" />
                                </div>
                            </div>
                            <input type="text" class="form-control" disabled style="text-align: center;" :value="item.skor==null?0:item.skor">
                            <div class="input-group-prepend">
                                <div class="input-group-text pointer" @click="increaseScore(index)">
                                    <font-awesome-icon style="color: #dc3545;" icon="fa-solid fa-circle-plus" />
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                        <div class="" v-else>
                            <span>{{ item.skor==null?0:item.skor }}</span>
                        </div>
                    </td>
                    <td>
                        <div v-if="idKustodian==userData.id&&(moment(dataPJO.tanggalPresentasi).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) && (dataSio.status!=5&&dataSio.status!=6)">
                            <div v-if="!item.isEditingNote" class="d-flex justify-content-between align-items-start gap-2">
                                <div class="flex-grow-1" style="min-width: 0;">
                                    <div
                                        class="text-wrap line-clamp-2 break-words"
                                        v-html="ncDescWithBreaks(item.catatan)"
                                    ></div>

                                    <h4
                                        v-if="isCatatanLong(item.catatan)"
                                        class="mt-1 font-semibold text-green-600 text-xs cursor-pointer hover:underline w-fit"
                                        @click="openTextDetail('Catatan', item.catatan, item.aspek)"
                                    >
                                        Lihat Selengkapnya
                                    </h4>
                                </div>
                                <div class="flex-shrink-0 ms-2">
                                    <font-awesome-icon 
                                        icon="fa-solid fa-pencil-alt" 
                                        @click="startEditNote(index)" 
                                        class="pointer" 
                                        style="color: #dc3545;" 
                                    />
                                </div>
                            </div>
                            <div v-else style="text-align: center;">
                                <textarea class="form-control" rows="2" v-model="item.editNote"></textarea>

                                <button class="btn btn_cari w-25" @click="saveEditNote(index)" style="margin-top: 5px; ">
                                    Simpan
                                </button>

                                <button class="btn btn-secondary" @click="cancelEditNote(index)" style="margin-top: 5px; margin-left: 5px;">
                                    Batalkan
                                </button>
                            </div>
                        </div>
                        <div v-else>
                            <div
                                class="text-wrap line-clamp-2 break-words"
                                v-html="ncDescWithBreaks(item.catatan)"
                            ></div>

                            <h4
                                v-if="isCatatanLong(item.catatan)"
                                class="mt-1 font-semibold text-green-600 text-xs cursor-pointer hover:underline w-fit"
                                @click="openTextDetail('Catatan', item.catatan, item.aspek)"
                            >
                                Lihat Selengkapnya
                            </h4>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td style="background: #ebecec; text-align: center;" colspan="2">Total</td>
                    <td style="background: #ebecec;">{{ totalMaxScore }}</td>
                    <td style="background: #ebecec;" colspan="2">{{ totalScore }}</td>
                </tr>
                <tr>
                    <td style="background: #e0e2e4; text-align: center;" colspan="2">Score</td>
                    <td style="background: #e0e2e4;"></td>
                    <td style="background: #e0e2e4;" colspan="2">{{ finalScore }}</td>
                </tr>
            </tfoot>
        </table> 
        </template>
    </div>
    <div class="evaluation-table-container" v-else>
        <div class="p-2">
                Nama Kustodian : <b>{{ namaKustodian}}</b>
            </div >
        <table class="evaluation-table">
            <thead>
                <tr class="evaluation-table-heading">
                    <th style="background-color: #f8d7da; width: 7%;">
                        No.
                    </th>
                    <th style="background-color: #f8d7da; width: 33%;">
                        Kriteria Penilaian
                    </th>
                    <th style="background-color: #f8d7da; width: 7%;">
                        Skor Max
                    </th>
                    <th style="background-color: #f8d7da; width: 17%;">
                        Skor
                    </th>
                    <th style="background-color: #f8d7da; width: 36%;">
                        Catatan
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in evaluationItems" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.aspek }}</td>
                    <td>{{ item.skorMax==null?defaultSkorMax:item.skorMax }}</td>
                    <td> 
                        <div class="input-group" style="width: 150px;" v-if="idKustodian==userData.id&&(moment(dataPJO.tanggalPresentasi).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) && (dataSio.status!=5&&dataSio.status!=6)">
                            <div class="input-group-prepend">
                                <div class="input-group-text pointer" @click="decreaseScore(index)">
                                    &nbsp;
                                    <font-awesome-icon style="color: #dc3545;" icon="fa-solid fa-circle-minus" />
                                </div>
                            </div>
                            <input type="text" class="form-control" disabled style="text-align: center;" :value="item.skor==null?0:item.skor">
                            <div class="input-group-prepend">
                                <div class="input-group-text pointer" @click="increaseScore(index)">
                                    <font-awesome-icon style="color: #dc3545;" icon="fa-solid fa-circle-plus" />
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                        <div class="" v-else>
                            <span>{{ item.skor==null?0:item.skor }}</span>
                        </div>
                    </td>
                    <td>
                        <div v-if="idKustodian==userData.id&&(moment(dataPJO.tanggalPresentasi).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) && (dataSio.status!=5&&dataSio.status!=6)">
                            <div v-if="!item.isEditingNote" class="d-flex justify-content-between align-items-start gap-2">
                                <div class="flex-grow-1" style="min-width: 0;">
                                    <div
                                        class="text-wrap line-clamp-2 break-words"
                                        v-html="ncDescWithBreaks(item.catatan)"
                                    ></div>

                                    <h4
                                        v-if="isCatatanLong(item.catatan)"
                                        class="mt-1 font-semibold text-green-600 text-xs cursor-pointer hover:underline w-fit"
                                        @click="openTextDetail('Catatan', item.catatan, item.aspek)"
                                    >
                                        Lihat Selengkapnya
                                    </h4>
                                </div>
                                <div class="flex-shrink-0 ms-2">
                                    <font-awesome-icon 
                                        icon="fa-solid fa-pencil-alt" 
                                        @click="startEditNote(index)" 
                                        class="pointer" 
                                        style="color: #dc3545;" 
                                    />
                                </div>
                            </div>
                            <div v-else style="text-align: center;">
                                <textarea class="form-control" rows="2" v-model="item.editNote"></textarea>

                                <button class="btn btn_cari w-25" @click="saveEditNote(index)" style="margin-top: 5px; ">
                                    Simpan
                                </button>

                                <button class="btn btn-secondary" @click="cancelEditNote(index)" style="margin-top: 5px; margin-left: 5px;">
                                    Batalkan
                                </button>
                            </div>
                        </div>
                        <div v-else>
                            <div
                                class="text-wrap line-clamp-2 break-words"
                                v-html="ncDescWithBreaks(item.catatan)"
                            ></div>

                            <h4
                                v-if="isCatatanLong(item.catatan)"
                                class="mt-1 font-semibold text-green-600 text-xs cursor-pointer hover:underline w-fit"
                                @click="openTextDetail('Catatan', item.catatan, item.aspek)"
                            >
                                Lihat Selengkapnya
                            </h4>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td style="background: #ebecec; text-align: center;" colspan="2">Total</td>
                    <td style="background: #ebecec;">{{ totalMaxScore }}</td>
                    <td style="background: #ebecec;" colspan="2">{{ totalScore }}</td>
                </tr>
                <tr>
                    <td style="background: #e0e2e4; text-align: center;" colspan="2">Score</td>
                    <td style="background: #e0e2e4;"></td>
                    <td style="background: #e0e2e4;" colspan="2">{{ finalScore }}</td>
                </tr>
            </tfoot>
        </table> 
    </div>

    <v-dialog v-model="dialogTextDetail" max-width="600" scrollable>
        <v-card class="rounded-xl">
            <div class="px-5 py-4 flex items-center justify-between border-b border-slate-100">
                <div>
                    <span v-if="textDetailCode" class="text-xs font-semibold px-2 py-0.5 rounded bg-slate-100 text-slate-700">
                        {{ textDetailCode }}
                    </span>
                    <h3 class="text-base font-bold text-slate-800 mt-1">
                        {{ textDetailTitle }}
                    </h3>
                </div>
                <button
                    type="button"
                    class="rounded-full p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                    @click="dialogTextDetail = false"
                >
                    <i class="mdi mdi-close text-xl"></i>
                </button>
            </div>
            <v-card-text class="p-5 text-sm text-slate-700 whitespace-pre-line leading-relaxed max-h-[60vh] overflow-y-auto">
                {{ textDetailContent }}
            </v-card-text>
            <div class="px-5 py-3 border-t border-slate-100 flex justify-end">
                <FormButton
                    variant="outlined"
                    classes="capitalize text-xs font-medium text-slate-600"
                    label="Tutup"
                    @click="dialogTextDetail = false"
                />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
import { isCatatanLong, ncDescWithBreaks } from "@/utilities/helpers";
import FormButton from "@/components/FormButton.vue";
// import Datepicker from "vuejs3-datepicker"
// import axios from "axios";
// import Swal from "sweetalert2" 

export default {
    mixins: [GlobalDataMixin],
    name: "formPenilaian",
    components: {
        FontAwesomeIcon,
        FormButton,
        // Datepicker
    },
    props: {
        dataPJO:{
            type:Object,
            // required:true,
        },
        dataSio:{
            type:Object,
            // required:true,
        },
        evaluationItems: Array,
        penilaians:Array,  
        idKustodian: Number,
        namaKustodian:String
    },
    data() {
        return { 
            localEvaluationItems: this.evaluationItems,
            defaultSkorMax:3,
            dialogTextDetail: false,
            textDetailTitle: '',
            textDetailContent: '',
            textDetailCode: '',
            // totalMaxScore:0,
            // totalScore:0,
            // finalScore:0,
        }
    },
    mounted() {
        // console.log(this.localEvaluationItems);
        // this.$nextTick(function () {
        //       // DOM is now updated
        //       // `this` is bound to the current instance
        //       console.log('aa',this.localEvaluationItems);  
            
        //     })
        
    },
    computed: {
        // totalMaxScore() {
            
        //     return this.localEvaluationItems.reduce((total, item) => total + item.skorMax, 0);
        // },
        // totalScore() {
        //     return this.localEvaluationItems.reduce((total, item) => total + item.skor, 0);
        // },
        finalScore() {
            return ((this.totalScore / this.totalMaxScore) * 100).toFixed(2);
        },
        totalMaxScore() {
            let totmaxs = 0;
            if(this.evaluationItems!=null){
                for (let z = 0; z < this.evaluationItems.length; z++) {
                    const element = this.evaluationItems[z];
                    if(element.skorMax==null){
                        totmaxs+=this.defaultSkorMax;
                    }else{
                        totmaxs+=element.skorMax;
                    }
                    
                }
            }
            
            return totmaxs;
            // return this.localEvaluationItems.reduce((total, item) => total + item.skorMax, 0);
        },
        totalScore() {
            let tots = 0;
            if(this.evaluationItems!=null){
                for (let z = 0; z < this.evaluationItems.length; z++) {
                    const element = this.evaluationItems[z];
                    tots+=element.skor;
                }
            }
            return tots;
            // return this.localEvaluationItems.reduce((total, item) => total + item.skor, 0);
        },
        
    },
    methods: { 
        // increaseScore(index) {
        //     if (this.localEvaluationItems[index].skor < this.localEvaluationItems[index].skorMax) {
        //         this.localEvaluationItems[index].skor++;
        //     }
        // },
        // decreaseScore(index) {
        //     if (this.localEvaluationItems[index].skor > 0) {
        //         this.localEvaluationItems[index].skor--;
        //     }
        // },
        // startEditNote(index) {
        //     this.localEvaluationItems[index].isEditingNote = true;
        //     this.localEvaluationItems[index].editNote = this.localEvaluationItems[index].catatan;
        // },
        // cancelEditNote(index) {
        //     this.localEvaluationItems[index].isEditingNote = false;
        // },
        // saveEditNote(index) {
        //     this.localEvaluationItems[index].catatan = this.localEvaluationItems[index].editNote;
        //     this.localEvaluationItems[index].isEditingNote = false;
        // },
        // updateEvaluationItems() {
        //     return this.localEvaluationItems;
        // },
        totalScoreAdmin(arr){
            let totscore = 0;
            for(let x=0;x<arr.length;x++){
                totscore += arr[x].skor;
            }
            return totscore;
        },
        totalMaxScoreAdmin(arr){
            let totscoreMax = 0;
            for(let x=0;x<arr.length;x++){
                totscoreMax += arr[x].skorMax;
            }
            return totscoreMax;
        },
        finalScoreAdmin(arr) {
            let totscore = 0;
            let totscoreMax = 0;
            for(let x=0;x<arr.length;x++){
                totscore += arr[x].skor;
                totscoreMax += arr[x].skorMax;
            }

            return ((totscore / totscoreMax) * 100).toFixed(2);
        },
        increaseScore(index) {
            if(this.evaluationItems[index].skorMax==null){
                if (this.evaluationItems[index].skor < this.defaultSkorMax) {
                    // eslint-disable-next-line
                    this.evaluationItems[index].skor++;
                }
            }else{
                if (this.evaluationItems[index].skor < this.evaluationItems[index].skorMax) {
                    // eslint-disable-next-line
                    this.evaluationItems[index].skor++;
                }
            }
            
        },
        decreaseScore(index) {
            console.log(this.evaluationItems[index])
            
            if (this.evaluationItems[index].skor > 0) {
                // eslint-disable-next-line
                this.evaluationItems[index].skor--;
            }
        },
        startEditNote(index) {
            // eslint-disable-next-line
            this.evaluationItems[index].isEditingNote = true;
            // eslint-disable-next-line
            this.evaluationItems[index].editNote = this.evaluationItems[index].catatan;
        },
        cancelEditNote(index) {
            // eslint-disable-next-line
            this.evaluationItems[index].isEditingNote = false;
        },
        saveEditNote(index) {
            // eslint-disable-next-line
            this.evaluationItems[index].catatan = this.evaluationItems[index].editNote;
            // eslint-disable-next-line
            this.evaluationItems[index].isEditingNote = false;
        },
        increaseScoreS(idx, index) {
            if(this.penilaians[idx].penilaian[index].skorMax==null){
                if (this.penilaians[idx].penilaian[index].skor < this.defaultSkorMax) {
                    // eslint-disable-next-line
                    this.penilaians[idx].penilaian[index].skor++;
                }
            }else{
                if (this.penilaians[idx].penilaian[index].skor < this.penilaians[idx].penilaian[index].skorMax) {
                    // eslint-disable-next-line
                    this.penilaians[idx].penilaian[index].skor++;
                }
            }
            
        },
        decreaseScoreS(idx,index) {
            
            
            if (this.penilaians[idx].penilaian[index].skor > 0) {
                // eslint-disable-next-line
                this.penilaians[idx].penilaian[index].skor--;
            }
        },
        startEditNoteS(idx,index) {
            // eslint-disable-next-line
            this.penilaians[idx].penilaian[index].isEditingNote = true;
            // eslint-disable-next-line
            this.penilaians[idx].penilaian[index].editNote = this.penilaians[idx].penilaian[index].catatan;
        },
        cancelEditNoteS(idx,index) {
            // eslint-disable-next-line
            this.penilaians[idx].penilaian[index].isEditingNote = false;
        },
        saveEditNoteS(idx,index) {
            // eslint-disable-next-line
            this.penilaians[idx].penilaian[index].catatan = this.penilaians[idx].penilaian[index].editNote;
            // eslint-disable-next-line
            this.penilaians[idx].penilaian[index].isEditingNote = false;
        },
        updateEvaluationItems() {
            return this.evaluationItems;
        },
        isCatatanLong(text) {
            return isCatatanLong(text);
        },
        ncDescWithBreaks(text) {
            return ncDescWithBreaks(text);
        },
        openTextDetail(title, content, code = "") {
            this.textDetailTitle = title;
            this.textDetailContent = content;
            this.textDetailCode = code;
            this.dialogTextDetail = true;
        }
    },
    watch: {
        updateEvaluationItems(newValue) {
            this.$emit('updateEvaluationItems', newValue);
        },
    }
}
</script>

<style> 
.evaluation-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-bottom: 1rem;
} 

.evaluation-table th,
.evaluation-table td {
  padding: 0.75rem;
  border: 1px solid #dee2e6;
} 

.evaluation-table td {
  background-color: #ffffff; /* White background for table cells */
}

.evaluation-table input[type="radio"] {
  margin-right: 5px; /* Spacing between radio buttons */
} 

.evaluation-table tfoot td {
  font-weight: bold;
  border: none;
}
</style>
